import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  nationwideCoverageText: {
    id: 'lQNlCQ',
    defaultMessage: 'Nationwide Coverage',
    description: 'Text indicating nationwide coverage for FBS service',
  },
  orderAccuracyStat: {
    id: 'uM8ga0',
    defaultMessage: '99.9%',
    description: 'Percentage stat for order accuracy',
  },
  orderAccuracyLabel: {
    id: 'U2LR8Q',
    defaultMessage: 'Order accuracy',
    description: 'Label for order accuracy metric',
  },
  onTimeStat: {
    id: 'wRp/qZ',
    defaultMessage: '99.5%',
    description: 'Percentage stat for on-time shipments',
  },
  onTimeLabel: {
    id: 'xq52O5',
    defaultMessage: 'Orders shipped on time',
    description: 'Label for on-time shipment metric',
  },
});
